import adminApiClient from './adminApiClient';

const adminSubscriptionService = {
  getCmmsForCompany: async (companyId) => {
    try {
      return await adminApiClient.get(`/api/subscriptions/cmms/company/${companyId}`);
    } catch {
      return null;
    }
  },

  getChatbotForCompany: async (companyId) => {
    try {
      return await adminApiClient.get(`/api/subscriptions/chatbot/company/${companyId}`);
    } catch {
      return null;
    }
  },

  getBothForCompany: async (companyId) => {
    const [cmms, chatbot] = await Promise.all([
      adminSubscriptionService.getCmmsForCompany(companyId),
      adminSubscriptionService.getChatbotForCompany(companyId),
    ]);
    return { cmms, chatbot };
  },

  // Assign a new subscription to a company
  assignCmms:    (data) => adminApiClient.post('/api/subscriptions/cmms', data),
  assignChatbot: (data) => adminApiClient.post('/api/subscriptions/chatbot', data),

  // Change plan on an existing subscription
  upgradeCmms:    (companyId, planId) =>
    adminApiClient.put(`/api/subscriptions/cmms/${companyId}/upgrade?newPlanId=${planId}`),
  upgradeChatbot: (companyId, planId) =>
    adminApiClient.put(`/api/subscriptions/chatbot/${companyId}/upgrade?newPlanId=${planId}`),

  cancelCmms:    (companyId) => adminApiClient.delete(`/api/subscriptions/cmms/${companyId}`),
  cancelChatbot: (companyId) => adminApiClient.delete(`/api/subscriptions/chatbot/${companyId}`),
};

export default adminSubscriptionService;
